export default {
  'all.table.customerName': 'Customer name',
  'all.table.carbontreasures': 'The number of carbon treasures',
  'all.table.numberShips': 'Total number of ships',
  'all.table.numberShips1': 'Number of ships',
  'all.table.shiptype': 'Ship type',
  'all.table.Contactperson': 'Contact person',
  'all.table.contactInformation': 'Contact details',
  'all.table.Contactaddress': 'Contact address',
  'all.table.totalcarbonemission': 'Total carbon emission',
  'all.table.Dateofregistration': 'Date of registration',
  'all.table.ExpirationDate': 'Date of expiration ',
  'all.table.NameOfShip': 'Name of ship',
  'all.table.shipowner': 'Shipowner',
  'all.table.shipyard': 'Shipyard',
  'all.table.FlagState': 'Flag state',
  'all.table.NameofshipinEnglish': 'Name of ship in English',
  'all.table.registerNo': 'Ship register No',
  'all.table.IMONumber': 'IMO No.',
  'all.table.IMO': 'IMO',
  'all.table.PortOfDeparture': 'Port of departure',
  'all.table.DepartureTime': 'Departure time',
  'all.table.PortOfArrival': 'Port of arrival',
  'all.table.ArrivalTime': 'Arrival Time',
  'all.table.SailingDistance': 'Sailing distance (nautical miles)',
  'all.table.SailingDistance1': 'Sailing distance',
  'all.table.SailingTime': 'Sailing time (min)',
  'all.table.SailingTime1': 'Sailing time',
  'all.table.TotalHeavyOilConsumption': 'Total heavy oil consumption (tons)',
  'all.table.deviceNo': 'Equipment number',
  'all.table.deviceStatus': 'Equipment status',
  'all.table.belong': 'Customer',
  'all.table.hardwareversion': 'Hardware version',
  'all.table.Softwareversion': 'Software version',
  'all.table.activetime': 'Activation time',
  'all.table.Validity': 'Validity period',

  'all.table.userName': 'User name',
  'all.table.nickName': 'Nickname',
  'all.table.gender': 'Gender',
  'all.table.phoneNumber': 'Phone numbe',
  'all.table.email': 'Email',
  'all.table.creationTime': 'Creation time',
  'all.table.creator': 'Creator',
  'all.table.Operation': 'Operation',
  'all.table.Status': 'Status',
  'all.table.Emissionreport': 'Emission report',
  'all.table.Monitoringplan': 'Monitoring plan',
  'all.table.Storagetime': 'Storage time',
  'all.table.shipclassification': "Ship's classification",
  'all.table.Totaltonnage': 'Total tonnage',
  'all.table.Deadweighttonnage': 'Deadweight',
  'all.table.Nettonnage': 'Net tonnage',
  'all.table.TEU': 'TEU',
  'all.table.Cargounitcapacity': 'Cargo unit capacity',
  'all.table.Cargounitcapacity1': 'Each capacity cargo unit',
  'all.table.DWT': 'DWT',
  'all.table.Designaccommodate': 'Designed accommodate',
  'all.table.storageCapacity': 'Storage capacity(m³)',
  'all.table.Lengthbetweenwaterlines': 'Waterline length(m)',
  'all.table.Designdraft': 'Design draft(m)',
  'all.table.Shipwidth': 'Ship width(m)',
  'all.table.MCR': 'MCR(kw)',
  'all.table.auxiliaryEnginePowers': 'Auxiliary Engine Powers(kw)',
  'all.table.SFC': 'EEXI SFC(g/kWh)',
  'all.table.auxiliaryEngineMode': 'Auxiliary Engine Mode',
  'all.table.2-stroke': '2-stroke',
  'all.table.4-stroke': '4-stroke',
  'all.table.iceClass': 'Ice-class',
  'all.table.PPTOi': 'PPTOi(kw)',
  'all.table.eediEvi': 'EEDI or EVI',
  'all.table.eediEviContext': 'Eedi or Evi Context',
  'all.table.ManagementDate': 'Management date',
  'all.table.ManagementDates': 'Management startDate',
  'all.table.ManagementDatee': 'Management endDate',
  'all.table.shipPic': 'Ship Pic',
  'all.table.monitorPlanStatus': 'Monitor Plan Status',
  'all.table.monitorPlanFile': 'Monitor Plan File',
  'all.table.dischargeReportStatus': 'Discharge ReportStatus',
  'all.table.dischargeReportFile': 'Discharge ReportFile',
  'all.table.principal': 'Director',
  'all.table.shipmessage': 'Ship message',

  'all.table.Speed': 'Speed',
  'all.table.completionDate': 'Completion date',
  'all.table.voyagerecords': 'Voyage records',
  'all.table.Voyagetime': 'Voyage time',

  'all.modal.newUser': 'New user',

  'all.table.role': 'Role',
  'all.table.Rights': 'Rights',
  'all.table.noiPermission': 'Permission not yet assigned',
  'all.table.Voyagedate': 'Voyage date',

  'all.table.index': 'Index',
  'all.table.Fueltype': 'Types of energy sources',
  'all.table.unit': 'Unit',
  'all.table.Oils': 'Oils',
  'all.table.oilconsumption': 'Oil consumption',

  'all.table.associatedship': 'Associated ship',
  'all.table.loginUserName': 'login UserName',
  'all.table.uploadtime': 'Upload time',
  'all.table.annual': 'Annual',
  'all.table.annual1': 'Annual',
  'all.table.ClassificationSocietyDocuments': 'Classification Society files',
  'all.table.ClassificationSociety': 'Classification Society',
  'all.table.ShipRegistration': 'Ship registration',
  'all.table.protocolFile': 'Protocol File',
  'all.table.Loadingcapacity': 'Loading capacity(ton)',
  'all.table.Totalconsumption': 'Total consumption of heavy oil(ton)',
  'all.table.Parkingtime': 'Parking time',
  'all.table.Consumptionofvarioustypesofheavyoil': 'Consumption of various types of heavy oil',
  'all.table.voyagemessage': 'Voyage message',
  'all.table.Ancillarydocuments': 'Ancillary file',
  'all.table.Statisticalcycle': 'Statistical cycle',
  'all.table.voyageRecordCount': 'Voyage recordCount',
  'all.table.calculation': 'Calculation',
  'all.table.Improvementmeasures': 'Improvement measures',
  'all.table.Energysavingtechnology': 'Energy-saving technology',
  'all.table.Percentageofenergysaving': 'Percentage of energy saving',
  'all.table.company': 'Shipping company',
  'all.table.Calculaterating': 'Calculate rating',
  'all.table.BasicSettings': 'Basic Settings',
  'all.table.Username': 'User name',
  'all.table.AccountnumberID': 'Account ID',
  'all.table.avatar': 'Avatar',
  'all.table.changeavatar': 'Change the avatar',
  'all.table.Updatebasicinformation': 'Update basic information',
  'all.table.corporatename': 'Corporate name',
  'all.table.titleforSys': 'Energy efficiency management system',
  'all.table.titleforSys1': 'Password inconsistency',
  'all.table.titleforSys2': 'Password must be consistent',
  'all.table.titleforSys3': 'Password changed successfully',
  'all.table.titleforSys4': 'Change Password',
  'all.table.titleforSys5': 'New password',
  'all.table.titleforSys6': 'Confirm password',
  'all.table.titleforSys7': 'Confirm New password',
};
